<div class="continer-fluid">
    <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
            <h3>New SMS Template</h3>
            <form [formGroup]=templateFrom>
                <div class="form-row">
                    <div class="form-group col-12">
                        <label for="">SMS Template</label>
                        <textarea name="" id="" cols="30" rows="10" formControlName="template" class="form-control"></textarea>
                    </div>
                    <div class="form-group col-12">
                        <label for="">Bank</label>
                        <select formControlName="bank_id" class="form-control">
                            <option *ngFor="let item of BankList" [value]="item._id" >{{item.bank_name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">Product</label>
                        <select formControlName="product_id" class="form-control">
                            <option *ngFor="let item of ProductList" [value]="item._id" >{{item.product_type}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">Portfolio</label>
                        <select formControlName="portfolio_id" class="form-control">
                            <option *ngFor="let item of PortfolioList" [value]="item._id" >{{item.portfolio_type}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">Bucket</label>
                        <select formControlName="bucket_id" class="form-control">
                            <option *ngFor="let item of BucketList" [value]="item.bucket_id" >{{item.bucket_id}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12">
                        <label for="">Status</label>
                        <select formControlName="status" class="form-control">
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>
                </div>
                <div class="row d-flex justify-content-end">
                    <button class="btn btn-sm btn-success mr-2" *ngIf="addmode" (click)="addSMS()">ADD</button>
                    <button class="btn btn-sm btn-dark mr-2" *ngIf="addmode" (click)="editSMS()">EDIT</button>
                    <button class="btn btn-sm btn-primary mr-2" *ngIf="editmode" (click)="updateSMS()">UPDATE</button>
                    <button class="btn btn-sm btn-warning mr-2" *ngIf="editmode" (click)="cancelSMS()">CANCEL</button>
                </div>
            </form>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="row">
                <div class="col-12">
                    <h3>SMS Template List</h3>
                    <div class="row d-flex justify-content-end">
                        <button class="btn btn-sm btn-danger mr-2 mb-2"  (click)="deleteSMS()">DELETE</button>
                        <button class="btn btn-sm btn-warning mr-2 mb-2"  (click)="cancelSMS()">CANCEL</button>
                    </div>
                    <div class="card">
                        <ag-grid-angular #agGrid 
                        style="width: auto; height: 500px;"
                        class="ag-theme-alpine"
                        [rowData]="SMSTemplateList"
                        [rowSelection]="'multiple'"
                        [columnDefs]="SMScolumnDefs"
                        [pagination]="true">
                    </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>